<template>
  <div class="developer-finance">
    <h3 class="developer-finance__title">Finance</h3>

    <v-form class="developer-finance__content">
      <v-row>
        <v-col class="developer-finance__col">
          <v-text-field
            v-model="developer.finance.rate"
            class="developer-finance__rate form-field"
            :rules="[rules.required, rules.positive]"
            dense
            label="Rate"
            placeholder="Type hourly rate..."
            suffix="/ h"
            type="number"
            @input="showSaveButton"
          />
          <v-select
            v-model="developer.finance.currency"
            class="developer-finance__currency form-field"
            :items="featuresData.currency"
            dense
            flat
            disabled
            label="Currency"
            placeholder="Choose"
            @change="showSaveButton"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col class="developer-finance__col">
          <v-text-field
            v-model="developer.finance.rate_with_margin"
            class="developer-finance__rate form-field"
            :rules="[rules.required, rules.positive]"
            dense
            label="Rate with margin"
            placeholder="Type hourly rate..."
            suffix="/ h"
            type="number"
            @input="showSaveButton"
          />
          <v-select
            v-model="developer.finance.currency"
            class="developer-finance__currency form-field"
            :items="featuresData.currency"
            dense
            flat
            disabled
            label="Currency"
            placeholder="Choose"
            @change="showSaveButton"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col class="developer-finance__col">
          <v-select
            v-model="developer.finance.working_hours"
            class="form-field"
            :items="featuresData.working_hours"
            dense
            multiple
            item-color="blue"
            label="Time availability"
            placeholder="Choose your preferences"
            @change="showSaveButton"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col class="developer-finance__col">
          <v-select
            v-model="developer.finance.contract_types"
            class="form-field"
            :items="featuresData.contract_types"
            dense
            multiple
            item-color="blue"
            label="Type of contract"
            placeholder="Choose your contract"
            @change="showSaveButton"
          />
        </v-col>
      </v-row>

      <v-row v-if="isSaveBtnVisible">
        <v-col class="developer-finance__col mt-2">
          <v-btn
            color="blue"
            medium
            dark
            :loading="isSubmitProcessing"
            @click="saveChanges"
          >
            SAVE CHANGE
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import validationRules from '@/helpers/validators';

const rules = validationRules;

export default {
  data() {
    return {
      rules,
      isSaveBtnVisible: false,
    };
  },

  computed: {
    ...mapState('hrDeveloper', [
      'developer',
      'isSubmitProcessing',
    ]),

    ...mapState('features', [
      'featuresData',
    ]),
  },

  methods: {
    ...mapActions('hrDeveloper', [
      'updateDeveloper',
    ]),

    showSaveButton() {
      this.isSaveBtnVisible = true;
    },

    saveChanges() {
      this.updateDeveloper()
        .then(() => {
          this.isSaveBtnVisible = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.developer-finance {
  margin-bottom: 24px;
  padding: 16px 24px;
  background: #FFFFFF;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 8px;

  &__title {
    color: $color--primary;
    font-size: 18px;
    line-height: 21px;
    font-weight: 500;
    margin-bottom: 16px;
  }

  &__rate {
    display: inline-block;
    width: calc(100% - 128px);
  }
  &__currency {
    width: 120px;
    margin-left: 8px;
    display: inline-block;
    @include desktop {
      max-width: 30%;
    }
  }

  &__col {
    padding-top: 0;
    padding-bottom: 4px;
  }

  .form-field {
    max-width: 100%;

    @include desktop {
      max-width: 256px;
    }
  }
}
</style>
